import { render, staticRenderFns } from "./plEnterTgLink.vue?vue&type=template&id=3fc7cf86&scoped=true"
import script from "./plEnterTgLink.vue?vue&type=script&lang=js"
export * from "./plEnterTgLink.vue?vue&type=script&lang=js"
import style0 from "./plEnterTgLink.vue?vue&type=style&index=0&id=3fc7cf86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc7cf86",
  null
  
)

export default component.exports